import { Component, Renderer2 } from '@angular/core';
import { DatabaseService } from 'src/_services/DatabaseService'
import { AuthGuard } from './auth.guard';
import { sessionStorage } from './localstorage.service';
import { BnNgIdleService } from 'bn-ng-idle';
import { Router } from '@angular/router';
// import
// import { LocalStorage } from './localstorage.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'plywood';
  login_data:any={};
  kei_user:any;

  constructor(public serve:DatabaseService,public session:sessionStorage,public router:Router,public renderer:Renderer2,private bnIdle: BnNgIdleService){
    this.session.getSession()
    .subscribe(resp=>{
      this.login_data = resp.data;
    });
  }
  ngOnInit(): void {
    // Hide splash screen immediately when Angular is ready (no need to wait for window.onload)
    const splashScreen = document.getElementById("splashScreen");
    if (splashScreen) {
      splashScreen.classList.add("splashScreenFadeHide");
      splashScreen.addEventListener('transitionend', () => {
        splashScreen.style.display = 'none';
      });
    }
     
    this.bnIdle.startWatching(1800).subscribe((isTimedOut: boolean) => {
      if (isTimedOut) {
        this.session.LogOutSession();
        this.router.navigate(['']);
        this.kei_user = JSON.parse(localStorage.getItem('st_user')) || [];
        this.kei_user = {};
        this.kei_user.st_log = false;
        localStorage.removeItem('st_user');
      }

    });

  };
}
